import React from 'react'
import { useDispatch } from 'react-redux'
import { setKeyDataPendingOrders, setKeyDataContact, setOrderDetailIsOpen, setExistingPaymentLink } from '../../../redux/features/keyDataSlice';
import { formatDate } from '../../../utils/dateUtils';
import { toast } from 'react-toastify';
import useManageOrder from '../../order/useManageOrder';
import {
  PencilIcon,
  ArchiveBoxArrowDownIcon
} from '@heroicons/react/24/solid'

const NewOrder = ({group}) => {
  const dispatch = useDispatch()
  const { checkExistingPaymentLink } = useManageOrder();

  const handleSelect = async (group) => {
    // Check for existing payment link only if this is a company customer
    if (group.isCompanyCustomer && group.orders && group.orders.length > 0) {
      const urls = group.orders.map(order => order.url).filter(Boolean);
      const smileName = group.smileName;

      if (urls.length > 0 && smileName) {
        try {
          const response = await checkExistingPaymentLink({
            urls,
            smileName,
            paymentType : 'first'
          });
          
          if (response && response.canReuse) {

            // Store the existing payment link info in Redux
            dispatch(setExistingPaymentLink({
              canReuse: true,
              paymentUrl: response.paymentUrl,
              isCreditCard: response.isCreditCard
            }));
          } else {
            // Clear any existing payment link info
            dispatch(setExistingPaymentLink(null));
          }
        } catch (error) {
          console.error('Error checking existing payment link:', error);
          // Clear any existing payment link info on error
          dispatch(setExistingPaymentLink(null));
        }
      } else {
        // Clear any existing payment link info if no valid data
        dispatch(setExistingPaymentLink(null));
      }
    } else {
      // Clear any existing payment link info for non-company customers
      dispatch(setExistingPaymentLink(null));
    }

    // Proceed with the original selection logic
    dispatch(setKeyDataPendingOrders(group))
    dispatch(setKeyDataContact(group.contact))
  }

  const handleOrderDetail = (e) => {
    e?.stopPropagation?.();
    // Ensure this group is selected so the modal has the correct profile/orders (avoids white screen when profile was null)
    dispatch(setKeyDataPendingOrders(group));
    dispatch(setKeyDataContact(group.contact));
    dispatch(setOrderDetailIsOpen(true));
  }

  const getLatestOrderDate = (orders) => {
    if (orders.length === 0) return null; // No orders to compare
  
    // Convert string dates to Date objects for comparison
    const dates = orders.map(order => new Date(order.orderDate));
  
    // Find the latest date
    const latestDate = new Date(Math.max(...dates));
  
    // Convert back to a string format, if needed (e.g., 'YYYY-MM-DD')
    return latestDate.toISOString().split('T')[0];
  };

  return (
    <div>
      <div className={`border-b py-3 pb-3 border-blue-500 flex cursor-pointer ${group.note ? 'bg-blue-300' : ''}`} onClick={() => handleSelect(group)}>
        <div>
          {group.contact} - {group.orders.length} orders
          <div>
            {formatDate(getLatestOrderDate(group.orders))}
          </div>
        </div>
        <div className='ml-auto flex'>
          <PencilIcon onClick={(e) => handleOrderDetail(e)} className="h-6 w-6 mx-2 " />
          {/* <ArchiveBoxArrowDownIcon className="h-6 w-6"/> */}
        </div>
      </div>
    
    </div>
  )
}

export default NewOrder;